import { z } from 'zod';

export const CategoryShareSchema = z.object({
  label: z.string(),
  count: z.number().int().nonnegative(),
  percent: z.number().min(0).max(100),
});

export type CategoryShare = z.infer<typeof CategoryShareSchema>;

export const ChartArchetypeDistributionSchema = z.object({
  hcpCount: z.number().int().nonnegative(),
  generatedAt: z.string(),
  slices: z.array(CategoryShareSchema),
});

export const ChartRegimenTypeMixSchema = z.object({
  hcpCount: z.number().int().nonnegative(),
  generatedAt: z.string(),
  slices: z.array(CategoryShareSchema),
});

export const ChartAntiCd38SplitSchema = z.object({
  hcpCount: z.number().int().nonnegative(),
  generatedAt: z.string(),
  slices: z.array(CategoryShareSchema),
});

export const ChartDecisionMakingStyleSchema = z.object({
  hcpCount: z.number().int().nonnegative(),
  generatedAt: z.string(),
  slices: z.array(CategoryShareSchema),
});

export const ChartTopConstraintsSchema = z.object({
  hcpCount: z.number().int().nonnegative(),
  generatedAt: z.string(),
  slices: z.array(CategoryShareSchema),
});

export const ChartPatientMixSchema = z.object({
  hcpCount: z.number().int().nonnegative(),
  generatedAt: z.string(),
  slices: z.array(CategoryShareSchema),
});

export const ChartTolerabilityRankingSchema = z.object({
  hcpCount: z.number().int().nonnegative(),
  generatedAt: z.string(),
  slices: z.array(CategoryShareSchema),
});

export const ChartEndpointImportanceSchema = z.object({
  hcpCount: z.number().int().nonnegative(),
  generatedAt: z.string(),
  slices: z.array(CategoryShareSchema),
});

export const ChartDeescalationOrderSchema = z.object({
  hcpCount: z.number().int().nonnegative(),
  generatedAt: z.string(),
  slices: z.array(CategoryShareSchema),
});

export const ChartTopInformationSourcesSchema = z.object({
  hcpCount: z.number().int().nonnegative(),
  generatedAt: z.string(),
  slices: z.array(CategoryShareSchema),
});

export const ChartRegimenChoiceDriversSchema = z.object({
  hcpCount: z.number().int().nonnegative(),
  generatedAt: z.string(),
  slices: z.array(CategoryShareSchema),
});

export type ChartArchetypeDistribution = z.infer<typeof ChartArchetypeDistributionSchema>;
export type ChartRegimenTypeMix = z.infer<typeof ChartRegimenTypeMixSchema>;
export type ChartAntiCd38Split = z.infer<typeof ChartAntiCd38SplitSchema>;
export type ChartDecisionMakingStyle = z.infer<typeof ChartDecisionMakingStyleSchema>;
export type ChartTopConstraints = z.infer<typeof ChartTopConstraintsSchema>;
export type ChartPatientMix = z.infer<typeof ChartPatientMixSchema>;
export type ChartTolerabilityRanking = z.infer<typeof ChartTolerabilityRankingSchema>;
export type ChartEndpointImportance = z.infer<typeof ChartEndpointImportanceSchema>;
export type ChartDeescalationOrder = z.infer<typeof ChartDeescalationOrderSchema>;
export type ChartTopInformationSources = z.infer<typeof ChartTopInformationSourcesSchema>;
export type ChartRegimenChoiceDrivers = z.infer<typeof ChartRegimenChoiceDriversSchema>;

export const SEGMENT_CHART_KEYS = [
  'chartArchetypeDistribution',
  'chartRegimenTypeMix',
  'chartAntiCd38Split',
  'chartDecisionMakingStyle',
  'chartTopConstraints',
  'chartPatientMix',
  'chartTolerabilityRanking',
  'chartEndpointImportance',
  'chartDeescalationOrder',
  'chartTopInformationSources',
  'chartRegimenChoiceDrivers',
] as const;

export type SegmentChartKey = (typeof SEGMENT_CHART_KEYS)[number];
